angular.module('ui-ng-drag-drop').service('dragDropDelegate', function dragDropDelegate(DelegateController) {
  DelegateController(this, {
    uniqueComponent: 'drag-drop',
    vocabulary: {}
  });
});



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-drag-drop/src/custom/drag_drop_delegate.js